<template>
	<div>
		<el-dialog :visible.sync="show" width="70%" :close-on-click-modal="false" :before-close="closeDialog">
			<div class="adminMessage">管理员信息</div>
			<el-form ref="form" :model="submit_data" label-width="100px">

				<el-row>
					<el-col :span="12">
						<el-form-item label="用户名:">
							<el-input v-model="submit_data.user_name" maxlength="20" minlength="8"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="昵称:">
							<el-input v-model="submit_data.name" maxlength="20" minlength="8"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="密码:">
							<el-input v-model="submit_data.password" type="password"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="重复密码:">
							<el-input v-model="repetition_password" type="password"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="绑定电话:">
							<el-input v-model="submit_data.phone"></el-input>
						</el-form-item>
					</el-col>

				</el-row>





				<el-row>
					
					<el-col :span="12">
						<el-form-item label="用户状态:">
							<template>
								<el-select v-model="value_status_code" placeholder="请选择管理状态" style="width: 150px; margin-right: 20px;"
									@change="statusChange" clearable>
									<el-option v-for="(item, index) in value_status_array" :label="item.alias" :value="item.val">
									</el-option>

								</el-select>
							</template>
						</el-form-item>
					</el-col>

				</el-row>



				<el-form-item label="注册时间:" label-width='100px'>
					<el-date-picker v-model="time_arrway" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
				</el-form-item>




				<el-form-item label="锁定:">
					<el-switch v-model="submit_data.locking" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>

				<el-form-item label="验证阈值:">
					<el-switch v-model="submit_data.verify" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>




				<template>
					<el-form-item label="角色选择:">
						<div class="juese">
							<el-radio-group v-model="submit_data.admin_role_code" size="mini">
								<span v-for="(value,key) in admin_role_list">
									<el-radio :label="value.admin_role_code" border
										style="width:160px;margin-bottom:20px;margin-right: 5px;">
										{{value.name}}
									</el-radio>
									<el-button type="text" style="margin-right: 30px;" @click="toDetails(value.admin_role_code)">详情
									</el-button>
								</span>

							</el-radio-group>
						</div>
					</el-form-item>
				</template>


				<el-form-item label="指定用户:">
					<el-input v-for="(item,index) in only_consumer_code_array" v-model="only_consumer_code_array[index].phone" placeholder="请输入手机号码" maxlength="11" style="width: 200px"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button @click="addPhone">增加号码</el-button>
					<el-button @click="delPhone">移除号码</el-button>
				</el-form-item>


				<el-form-item>
					<el-button type="primary" @click="editRoleSubmit">确定</el-button>
					<el-button @click="closeDialog">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>



		<editCompanyDialog :isShow="comapny_isShow" :data="company_data"></editCompanyDialog>

		<!-- 编辑的弹窗子组件 -->
		<editRoleSubmit :isShow="editRoleSubmitShow" :editRole_data="editRole_code">
		</editRoleSubmit>

	</div>
</template>

<script>
	var _this;
	import editCompanyDialog from '../company/editCompanyDialog.vue';
	import editRoleSubmit from '../system/editRoleSubmit';

	export default {
		components: {
			editCompanyDialog,
			editRoleSubmit
		},

		props: {

			'isShow': Boolean,
			// 接受父组件传值
			'editRole_data': ''

		},
		//监听父组件传过来的值
		watch: {

			isShow(newData, oldData) {

				_this.show = true;

				_this.edit_data.admin_code = _this.editRole_data;

				_this.getAdminDetails();

				_this.adminRoleLists();


			},


		},

		data() {
			return {

				only_consumer_code_array:[],

				comapny_isShow: false,
				company_data: '',

				editRoleSubmitShow: false, //编辑的diglog
				editRole_code: '',


				// 重复密码
				repetition_password: '',

				// 存放时间
				time_arrway: '',

				// 下拉搜索管理状态
				value_status_code: '',
				value_status_array: [],

				// 角色
				admin_data: {
					admin_role_code: ''
				},

				// 角色选择遍历
				admin_role_list: [],





				// 编辑管理员
				edit_data: {
					admin_code: '',
				},

				submit_data: {
					// 管理员唯一编码
					admin_code: '',
					user_name: '',
					name: '',
					phone: '',
					status: '',
					locking: '',
					verify: '',
					// 角色唯一编码
					admin_role_code: '',
					only_consumer_code_array:''
				},


				city_name: '',
				show: false,
			};
		},
		created() {

			_this = this;

		},
		methods: {




			// 增加手机号
			addPhone(){
				_this.only_consumer_code_array.push({
					phone:''
				})
			},

			// 移除手机号
			delPhone(){
				if(_this.only_consumer_code_array.length>0){
					_this.only_consumer_code_array.pop()
				}

			},


			toDetails(code) {

				_this.editRoleSubmitShow = !_this.editRoleSubmitShow;
				_this.editRole_code = code;

			},

			toCompany() {

				_this.comapny_isShow = !_this.comapny_isShow;

				_this.company_data = _this.company_code;

			},




			// 角色选择列表
			adminRoleLists() {

				_this.$post(
					"/system/adminRoleLists", {
						page: 1,
						limit: 50
					}
				).then(res => {

					_this.admin_role_list = res.data;

				}).catch((err) => {

				})
			},

			// 管理员详情
			getAdminDetails() {

				_this.$post(
					"/system/getAdminDetails",
					_this.edit_data,
				).then(res => {


					_this.submit_data.admin_code = res.data.admin_code;

					_this.submit_data.user_name = res.data.user_name;

					_this.submit_data.name = res.data.name;

					_this.submit_data.phone = res.data.phone;


					_this.submit_data.locking = res.data.locking.val;

					_this.submit_data.status = res.data.status.val;

					_this.value_status_code = res.data.status.alias;

					_this.value_status_array = res.data.status.select_array;

					_this.submit_data.verify = res.data.verify.val;

					_this.submit_data.admin_role_code = res.data.admin_role_code;

					_this.submit_data.only_consumer_code_array = res.data.only_consumer_code_array;

					if(res.data.only_consumer_code_array.length>0){

						for (var i = 0; i<JSON.parse(res.data.only_consumer_code_array).length;i++){

							console.log(JSON.parse(res.data.only_consumer_code_array)[i]);

							_this.only_consumer_code_array.push({
								phone:JSON.parse(res.data.only_consumer_code_array)[i]
							})

						}

					}


					console.log(_this.only_consumer_code_array);


					_this.time_arrway = res.data.ban_time.YmdHis;




					_this.company_name = res.data.company.name;

					_this.admin_data.admin_role_code = res.data.admin_role_code;

					_this.value_status_code = res.data.status.alias;
					_this.value_status_array = res.data.status.select_array;




					if (_this.admin_data.admin_role_code != "") {

						// 角色详情
						_this.$post(
							"/system/getRoleDetails",
							_this.admin_data,

						).then(res => {


							_this.submit_data.admin_role_code = res.data.admin_role_code;

						}).catch((err) => {

						})

					} else {

						return false


					}


				}).catch((err) => {

				})
			},
			statusChange(val) {


				_this.submit_data.status = val.toString();

			},

			closeDialog() {

				_this.submit_data = {
					// 管理员唯一编码
					admin_code: '',
					user_name: '',
					name: '',
					phone: '',
					status: '',
					locking: '',
					verify: '',
					// 角色唯一编码
					admin_role_code: '',
					only_consumer_code_array:''
				};

				_this.only_consumer_code_array = [];
				_this.value_status_code = '';
				_this.show = false;
			},
			// 编辑角色
			editRoleSubmit() {




				var data = [];

				for (var i = 0;i<_this.only_consumer_code_array.length;i++){

					data.push(_this.only_consumer_code_array[i].phone);

				}

				_this.submit_data.only_consumer_code_array = JSON.stringify(data)


				// 如果密码不填则不传password




				_this.$post(
					"/system/editAdminSubmit",
					_this.submit_data
				).then(res => {

					_this.closeDialog();

					_this.$message.success(res.msg);

					var return_data = {
						page: 1,
						limit: 10,
						admin_role_code: '',
						user_name: '',
						name: '',
						phone: '',
						locking: '',
						status: '',
						verify: '',
					};

					_this.$emit("submit_ok_return", return_data);

				}).catch((err) => {

				})



			},
		}
	};
</script>
<style scoped>
	.juese {
		width: 70%;
		margin-top: 5px;
	}

	.row-list {

		display: flex;

		flex-direction: row;

		align-items: center;

		justify-content: flex-start;

		flex-wrap: wrap;


	}

	.row-list .el-form-item {

		display: flex;
		flex-direction: row;

		align-items: center;
		justify-content: flex-start;

		width: 50%;


	}

	.row-list .el-form-item .el-input {

		margin-left: 0;

	}


	.adminMessage {
		font-family: Microsoft YaHei;
		font-weight: 600;
		line-height: 21px;
		color: #222;
		margin-bottom: 20px;
		font-size: 18px;
	}

	.xiala {
		margin-left: 20px;
	}
</style>